import React, { useMemo } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ButtonStyles, { useLoaderStyles } from './styles';
import { VARIENT } from './constant';

const PPButton = ({
  id,
  reference,
  onClick: handleClick = () => {},
  label = '',
  color = 'primary',
  variant = VARIENT.contained,
  disabled = false,
  loading = false,
  startIcon,
  endIcon,
  classes,
  className,
  startGutter = false,
  endGutter = false,
  flexFill = false,
}) => {
  const loaderClasses = useLoaderStyles();

  const ButtonStyle = new Map([
    [VARIENT.contained, classes.buttonStyle],
    [VARIENT.cancel, classes.cancelButtonStyle],
    [VARIENT.outlined, classes.outlinedButtonStyle],
  ]);

  const _disabled = useMemo(() => (disabled || loading), [disabled, loading]);

  const Content = new Map([
    [false, label],
    [true, <CircularProgress className={loaderClasses.default} size={20} thickness={4} />]
  ]);

  return (
    <Button
      id={id}
      ref={reference}
      className={`${ButtonStyle.get(variant)} ${startGutter && classes.startGutter} ${endGutter && classes.endGutter} ${flexFill && classes.flexFill} ${className}`}
      color={color}
      onClick={handleClick}
      disabled={_disabled}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {Content.get(loading)}
    </Button>
  )
};

export default withStyles(ButtonStyles)(PPButton);
